import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class RegistrationDecodeService {
  private parsePlateUrl = `${GlobalVariable.BASE_API_URL_ELASTIC}/parse-car-register-plate`;
  private decodeUrl =  `${GlobalVariable.BASE_API_URL}/vehicle/decode`;

  constructor(private http: HttpClient) {}

  // Upload file for plate parsing
  parseCarRegisterPlate(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('showDetails', 'true');

    const headers = new HttpHeaders({
      accept: 'application/json',
      'x-api-key': '0685c929fe579454904f6ca97a6ab0b3',
    });

    return this.http.post<any>(this.parsePlateUrl, formData, { headers });
  }

  // Decode registration number
  decodeVehicle(regNo: string): Observable<any> {
    const regInput = regNo.replace(/\s+/g, '');
    const url = `${this.decodeUrl}/${encodeURIComponent(regInput)}`;
    return this.http.get<any>(url);
  }
}
